export function loadJS(fileUrl, name = 'unknown', async = true) {
  return new Promise((resolve, reject) => {
    try {
      const id = `dynamic-js-${name}`;
      let $script = document.getElementById(id);
      let isNew = false;

      if ($script === null) {
        $script = document.createElement('script');
        $script.type = 'text/javascript';
        $script.async = async;
        $script.id = id;
        $script.src = fileUrl;
        isNew = true;
      }

      if ($script.getAttribute('data-ready') === '1') {
        resolve({ status: true });
        return;
      }

      $script.addEventListener('load', () => {
        $script.setAttribute('data-ready', '1');
        resolve({ status: true });
      });

      $script.addEventListener('error', () => {
        reject(new Error(`Loading error for ${fileUrl}`));
      });

      if (isNew) document.head.appendChild($script);
    } catch (error) {
      reject(error);
    }
  });
}

export function loadCSS(fileUrl, name = 'unknown', async = true) {
  return new Promise((resolve, reject) => {
    try {
      const id = `dynamic-css-${name}`;
      let $link = document.getElementById(id);
      let isNew = false;

      if ($link === null) {
        $link = document.createElement('link');
        $link.rel = 'stylesheet';
        $link.async = async;
        $link.id = id;
        $link.href = fileUrl;
        isNew = true;
      }

      if ($link.getAttribute('data-ready') === '1') {
        resolve({ status: true });
        return;
      }

      $link.addEventListener('load', () => {
        $link.setAttribute('data-ready', '1');
        resolve({ status: true });
      });

      $link.addEventListener('error', () => {
        reject(new Error(`Loading error for ${fileUrl}`));
      });

      if (isNew) document.head.appendChild($link);
    } catch (error) {
      reject(error);
    }
  });
}

export default {
  loadJS,
  loadCSS,
};
